export default "__VITE_ASSET__CuYNrkPB__"